export const RedstoneChainLinkPriceOracleAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'pointerData', internalType: 'bytes', type: 'bytes' },
      {
        name: '_sequencerUptimeFeed',
        internalType: 'address',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'values', internalType: 'uint256[]', type: 'uint256[]' }],
    name: 'aggregateValues',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'checkSequencer',
    outputs: [],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'extractTimestampsAndAssertAllAreEqual',
    outputs: [{ name: 'extractedTimestamp', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'feedIds',
    outputs: [{ name: '_feedIds', internalType: 'bytes32[]', type: 'bytes32[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'signerAddress', internalType: 'address', type: 'address' }],
    name: 'getAuthorisedSignerIndex',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getDataServiceId',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getUniqueSignersThreshold',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    name: 'pricesAndBalances',
    outputs: [
      { name: '_prices', internalType: 'uint256[]', type: 'uint256[]' },
      { name: '_balances', internalType: 'uint96[]', type: 'uint96[]' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'sequencerUptimeFeed',
    outputs: [
      {
        name: '',
        internalType: 'contract AggregatorV3Interface',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'receivedTimestampMilliseconds',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'validateTimestamp',
    outputs: [],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    name: 'valuation',
    outputs: [
      { name: '_reservePrice', internalType: 'uint256', type: 'uint256' },
      { name: '_valuation', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'CalldataMustHaveValidPayload' },
  { type: 'error', inputs: [], name: 'CalldataOverOrUnderFlow' },
  { type: 'error', inputs: [], name: 'CanNotPickMedianOfEmptyArray' },
  { type: 'error', inputs: [], name: 'DataPackageTimestampMustNotBeZero' },
  { type: 'error', inputs: [], name: 'DataPackageTimestampsMustBeEqual' },
  { type: 'error', inputs: [], name: 'EachSignerMustProvideTheSameValue' },
  { type: 'error', inputs: [], name: 'EmptyCalldataPointersArr' },
  { type: 'error', inputs: [], name: 'GetDataServiceIdNotImplemented' },
  { type: 'error', inputs: [], name: 'GracePeriodNotOver' },
  { type: 'error', inputs: [], name: 'IncorrectUnsignedMetadataSize' },
  {
    type: 'error',
    inputs: [
      {
        name: 'receivedSignersCount',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'requiredSignersCount',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'InsufficientNumberOfUniqueSigners',
  },
  { type: 'error', inputs: [], name: 'InvalidCalldataPointer' },
  {
    type: 'error',
    inputs: [
      { name: '_size', internalType: 'uint256', type: 'uint256' },
      { name: '_start', internalType: 'uint256', type: 'uint256' },
      { name: '_end', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InvalidCodeAtRange',
  },
  {
    type: 'error',
    inputs: [],
    name: 'RedstonePayloadMustHaveAtLeastOneDataPackage',
  },
  { type: 'error', inputs: [], name: 'RoundMismatch' },
  { type: 'error', inputs: [], name: 'SequencerDown' },
  {
    type: 'error',
    inputs: [{ name: 'receivedSigner', internalType: 'address', type: 'address' }],
    name: 'SignerNotAuthorised',
  },
  { type: 'error', inputs: [], name: 'StalePrice' },
  {
    type: 'error',
    inputs: [
      {
        name: 'receivedTimestampSeconds',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'blockTimestamp', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'TimestampFromTooLongFuture',
  },
  {
    type: 'error',
    inputs: [
      {
        name: 'receivedTimestampSeconds',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'blockTimestamp', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'TimestampIsTooOld',
  },
  { type: 'error', inputs: [], name: 'WriteError' },
] as const
